import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarVisibilityService {
  private visibleSubject = new BehaviorSubject<boolean>(false);
  public visible$ = this.visibleSubject.asObservable();

  showSidebar() {
    this.visibleSubject.next(true);
  }

  hideSidebar() {
    this.visibleSubject.next(false);
  }
}
